var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card p-2"},[_vm._v("\n    "+_vm._s(_vm.address.address)+"\n    "),(_vm.address.is_airport && _vm.address.flight_number)?_c('div',[_vm._v("\n        ("+_vm._s(_vm.$t('orders.flight'))+" #"+_vm._s(_vm.address.flight_number)+")\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }